import $ from 'jquery';

const $spinner = $(`
    <div class="blockui-spinner">
        <img src="${tromplo.spinner_url}" alt="Spinner">
    </div>
`);

export const blockUi = $element => {
    const spinner = 'spinner-' + Math.round(Math.random() * 123);
    $spinner.fadeTo(300, 1);
    // $element.css('pointer-events', 'none').fadeTo(300, .5);
    $element.attr('data-spinner', spinner);

    /*
    const offset = $element.offset();
    const width = $element.outerWidth();
    const height = $element.outerHeight();
    const centerX = offset.left;
    const centerY = offset.top;
    $spinner.appendTo('body').attr('id', spinner).css('left', centerX + 'px').css('top', centerY + 'px').css('width', width + 'px').css('height', height + 'px');
    */
    $spinner.appendTo('.cart__items');
    $spinner.appendTo('.cart-widget');
    return $spinner;
};

export const unblockUi = $element => {
    const $spinner = $('#' + $element.attr('data-spinner'));
    $spinner.fadeTo(300, 0);
    $element.fadeTo(300, 1, () => {
        // $element.css('pointer-events', 'all');
        $spinner.remove();
        $element.removeAttr('data-spinner');
    });
};
